import React from "react";
import { Container } from "react-bootstrap";
import Row from "react-bootstrap/Row";
import { Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import PromoVid from "../../Assets/hydroponic video/promo.mp4";
import "../../App.css";
function Intro() {
  return (
    <>
      <Container fluid className="whitebgimg">
        <Row className="p-2">
          <Col lg={6} className="p-4">
            <div className="ratio ratio-16x9">
              <video controls muted className="rounded-4 p-2">
                <source src={PromoVid} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
              {/* <iframe
                                src={PromoVid}
                                title="Vimeo video"
                                allowFullScreen
                                autoplay="false"
                                className='rounded-4 p-2'
                            ></iframe> */}
            </div>
          </Col>
          <Col lg={6} className="p-4">
            <div className="p-2">
              

              <p className="px-2">
                Get robust and reliable electrical hardware engineered to
                withstand demanding field conditions and long-term usage.
              </p>
              <p className="px-2">
                Royal Green Energy specializes in high-performance pole line,
                tower line, and utility distribution components trusted across
                India for quality and durability.
              </p>
              <p className="px-2 fst-italic">
                {" "}
                “Precision You Can Trust — Performance You Can Build On.”
              </p>
            </div>
            <div className="p-2">
              <Link to="/Contact" className="btn btn-outline-success">
                <i className="fa-solid fa-circle-arrow-right fa-beat"></i> Learn
                More
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default Intro;
